import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Button,
    IconButton,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
    Typography
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";
import SearchItems from "../../dialog/SearchItems";
import { CommonIcons, icons } from "../../common/CommonIcons";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useTranslations } from '../../../hooks/useTranslations';

import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useLocations, locationTypes } from "../../../hooks/api/useLocations";

import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useStateTransferReturn } from "../../../hooks/state/loadFrom/documents/useStateTransferReturn";

import { validationSchema, initialValues, initialRowValues } from "../../../schema/documents/transferReturnSchema";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewTransferReturn({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const { getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.transferReturn.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, create } = useDocuments({ 
        documentType: documentTypes.transferReturn, 
        targetType: targetTypes.transferReturn 
    })
    const { list: listLocations } = useLocations({ locationType: locationTypes.location })

    const { updateFormikState, getFormikDependencyStates } = useStateTransferReturn()
    const [dataLocations, setDataLocations] = useState([])

    const availableLocations = getAvailableLocations();

    // const [searchDocumentConfig, setSearchDocumentConfig] = useState({
    //     show: false,
    //     documentType: documentTypes.transferReturn,
    //     keyword: ""
    // })

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.transferReturn.id,
        documentType: loadFromDocumentTypes.transferReturn.type,
        keyword: ""
    })

    const onSubmit = async (currentValues) => {

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const props = {
            location_id: currentValues.locationId,
            to_location_id: currentValues.toLocationId,
        }

        let items = [];

        currentValues.rows.map(item => {
            items.push({
                id: item?.itemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,
                qty: item?.qty,
                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price,
                props: {
                    scan_type: item?.scanType ? 1 : 0
                }
            })
            return false;
        })

        try {

            let data = {
                document,
                props,
                items,
                ...getFormikDependencyStates({ values })
            }

            const response = await create({ data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/transferReturns"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    // useEffect(() => {

    //     const searchParamsAction = searchParams.get('action');
    //     const searchParamsPayload = searchParams.get('payload');

    //     // console.log('searchParams', searchParamsAction, searchParamsPayload)

    //     if (searchParamsAction && searchParamsAction.toLowerCase() === 'duplicate') {
    //         setSearchDocumentConfig(prev => ({ ...prev, show: true, documentType: documentTypes.transferReturn, keyword: searchParamsPayload }))
    //     }

    // }, [])

    const fetchDataLocations = async () => {

        try {

            const props = {
                limit: -1,
                offset: 0,
                filterValue: [],
                sortInfo: {
                    id: "location_name",
                    dir: 0,
                }
            }

            const { data } = await listLocations(props)

            setDataLocations(data?.locations)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }
    }

    useEffect(() => {
        
        fetchDataLocations()

    }, [])

    useEffect(() => {

        setFieldValue(`toLocationId`, ``)
        setFieldValue(`toLocationName`, ``)

    }, [values.locationId])

    // const updateDefaultFields = () => {

    //     // update the auth data
    //     // setFieldValue("retailOutletUserId", authData?.profile?.user?.id)

    //     // get use the parent user id
    //     setFieldValue('userId', authData?.profile?.parent_user_id)

    //     if(selectLocationIds && selectLocationIds.length){
    //         const check = availableLocations.filter(i => i.id === selectLocationIds[0])
    //         // console.log('check', check)
    //         if(check.length){

    //             // use the selected one branch location id
    //             setFieldValue('shippingBranchId', check[0].branch_id)

    //             // use the selected one brandh billing branch id
    //             setFieldValue('billingBranchId', check[0].billing_branch_id)

    //         }
    //     }

    // }

    // useEffect(() => {

    //     updateDefaultFields()

    // }, [selectLocationIds])

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        // setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length > 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
            }
        }

    }, [getLocationIds])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;
                }
            })
        }

        return props
    }

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
            })

        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    <Grid container spacing={0.5} >

                                        <Grid item xs={12} sm={12} md={0.5} alignSelf={"center"}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3}>

                                            <SearchItems
                                                id={`rows.${index}.name`}
                                                handleOnCancel={() => { }}
                                                handleOnSearchChange={(event) => {
                                                    setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                }}
                                                handleOnSelect={({ id, item }) => {
                                                    setFieldValue(`rows.${index}.itemId`, item?.id)
                                                    setFieldValue(`rows.${index}.name`, item?.item_name)
                                                    setFieldValue(`rows.${index}.description`, item?.description)
                                                    setFieldValue(`rows.${index}.code`, item?.code)
                                                    setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                    setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                    setFieldValue(`rows.${index}.qty`, 1)
                                                    // setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                    setFieldValue(`rows.${index}.scanType`, item?.scan_type)
                                                }}
                                                textProps={{
                                                    disabled: true,
                                                    value: itemValues?.name ? itemValues.name : "",
                                                    error: Boolean(itemErrors?.name),
                                                    helperText: itemErrors?.name
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                disabled
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.code`}
                                                label={t("code")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.code ? itemValues.code : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.code)}
                                                helperText={itemErrors?.code}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={4}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.description`}
                                                label={t("description")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.description ? itemValues.description : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.description)}
                                                helperText={itemErrors?.description}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "center"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.qty`}
                                                label={
                                                    `${t('qty')} ${itemValues?.uomName ? "(".concat(itemValues.uomName, ")") : ""}`
                                                }
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.qty ? itemValues.qty : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.qty`, event.target.value);
                                                    // handleDisplayRowChange({ index, qty: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.qty)}
                                                helperText={itemErrors?.qty}
                                            />
                                        </Grid>

                                        {/* <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                disabled
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.price`}
                                                label="Price"
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.price ? itemValues.price : ""}
                                                onChange={handleChange}
                                            // error={Boolean(itemErrors?.price)}
                                            // helperText={itemErrors?.price}
                                            />
                                        </Grid> */}

                                        <Grid item xs={12} sm={12} md={2} display={"flex"} justifyContent={"center"} alignItems={"flex-start"}>
                                            <Tooltip
                                                title={itemValues?.scanType ? t("enabled") : t("disabled")}
                                            >
                                                <Button
                                                    fullWidth
                                                    color={
                                                        itemValues?.scanType ? "primary" : "primary"
                                                    }
                                                    variant={
                                                        itemValues?.scanType ? "contained" : "outlined"
                                                    }
                                                    onClick={() => {
                                                        console.log('itemValues.scanType', itemValues.scanType)
                                                        setFieldValue(`rows.${index}.scanType`, !itemValues.scanType)
                                                    }}
                                                    sx={{
                                                        mt: 1,
                                                        display: "flex",
                                                        flexDirection: 'row',
                                                        justifyContent: "center",
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <CommonIcons
                                                        name={icons.strictMode}
                                                        sx={{ width: 20, height: 20 }}
                                                    />
                                                    <Typography sx={{ fontSize: 16, ml: 1 }}>
                                                        {t('strictMode')}
                                                    </Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t('addItem')}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                        <></>
                    </Grid>
                </Grid>

            </Grid>
        )
    }

    const RenderFormLocation = () => {

        let locationsTo = [];

        // get the current available location To 
        if (values.locationId)
            locationsTo = dataLocations.filter(i => i.id !== values.locationId)

        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={10.5}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("fromLocation")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                setLocationIds([])
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(touched.toLocationId) && Boolean(errors.toLocationId)}
                        >
                            <InputLabel id="rack-label">{t("locationTo")}</InputLabel>
                            <Select
                                // labelId="rack-label"
                                // id="rack_id"
                                value={values?.toLocationId}
                                name={`toLocationId`}
                                label={t("locationTo")}
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`toLocationId`, event.target.value)
                                }}
                            >
                                {
                                    locationsTo && locationsTo.map((item, index) =>
                                        <MenuItem key={index} value={item.id}>{item.location_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.toLocationId && errors.toLocationId}
                            </FormHelperText>
                        </FormControl>

                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>

                {/* {JSON.stringify(errors)} */}
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }

                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                            {/* <FieldArray
                                    name="rows"
                                    render={(arrayHelpers) => {
                                        
                                        return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                    
                                    }}
                                /> */}
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>

            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t("selectOnly1Location"),
                        description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        // console.log('selected', selected)

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newTransferReturn })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newTransferReturn")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("transferReturns"),
                        props: {
                            href: getRoute('documents/transferReturns')
                        }
                    },
                    {
                        displayText: t("newTransferReturn"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

        </Box>
    )
}